import { TaskDueDateFragment } from "gql/graphql";
import { DateTimeFormatter } from "@/shared/formatters";
import { Hidable, Value } from "@/shared/value";
import { useTranslations } from "use-intl";
import { SeriesStatusLabel } from "@/modules/tasks/shared/ui/series-status-label";
import { getTaskDueDate, isRecurringTask } from "../completion";

/**
 * Срок задачи. Пустой срок — не пробел в данных, а «без срока»: список писал
 * «Неограниченно», а карточка и уведомление — «Не указано», хотя состояние одно.
 * Слово выбирается здесь один раз, поэтому везде читается одинаково.
 * У серии срок — следующее срабатывание, и пуст он только когда серия закончилась
 * (по расписанию) или её закрыли вручную.
 */
export function TaskDueDate({ data }: { data?: Hidable<TaskDueDateFragment> }) {
  return (
    <Value data={data}>
      {(task) => {
        const dueDate = getTaskDueDate(task);

        if (dueDate) {
          return <DateTimeFormatter value={new Date(dueDate)} />;
        }

        if (isRecurringTask(task)) {
          return (
            <span>
              <SeriesStatusLabel status={task.completion.status} />
            </span>
          );
        }

        return <Unlimited />;
      }}
    </Value>
  );
}

function Unlimited() {
  const t = useTranslations("Tasks");

  return <span>{t("Unlimited")}</span>;
}
